import { TemplateEngine } from "../../../js/lib/TemplateEngine";
import { LS2KIDS_CONSTANTS } from "./constants";

/**
 * formerly tlc.ls2kids.messaging
 */
export class KidsMessaging {
	constructor() { }
	static init() {
		KidsMessaging._containerEle = $("#" + LS2KIDS_CONSTANTS.Ids.Messaging.container);
		KidsMessaging._containerEle.hide();

		TemplateEngine.fetch(
			"tmpl/kids/messageView.html",
			LS2KIDS_CONSTANTS.Ids.Messaging.container,
			function () {
				KidsMessaging._mainEle = $("#" + LS2KIDS_CONSTANTS.Ids.Messaging.main);

				KidsMessaging._scout = KidsMessaging._containerEle.find('.scout');
				KidsMessaging._messageEle = KidsMessaging._mainEle.find("p");

				KidsMessaging.initEvents();

				if (KidsMessaging._showMessageAferload != null) {
					if (KidsMessaging._hideMessageAferload == null) {
						KidsMessaging.show(KidsMessaging._showMessageAferload);
					} else {
						KidsMessaging.showThenHide(
							KidsMessaging._showMessageAferload,
							KidsMessaging._hideMessageAferload
						);

						KidsMessaging._hideMessageAferload = null;
					}

					KidsMessaging._showMessageAferload = null;
				}
			}
		);
	}
	static show(message) {
		if (!KidsMessaging._messageEle) {
			KidsMessaging._showMessageAferload = message;
			return false;
		}

		clearTimeout(KidsMessaging._hideTimeout);
		clearTimeout(KidsMessaging._delayTimeout);

		KidsMessaging._delayTimeout = null;
		KidsMessaging._hideTimeout = null;
		KidsMessaging._confirmOptions = null;

		KidsMessaging._messageEle.html(message);
		KidsMessaging._containerEle.show();
		KidsMessaging._isShowing = true;
		return true;
	}
	/**
	 *
	 * @param {boolean=} force whether we want to force it, default is true
	 */
	static hide(force) {
		force = !force; // if we pass nothing, interpret as true, if we pass false thats true


		// if we are forcing the hide, or if there hideTimeout property isn't set
		if (!force || KidsMessaging._hideTimeout == null) {
			clearTimeout(KidsMessaging._hideTimeout);

			KidsMessaging._hideTimeout = null;
			KidsMessaging._confirmOptions = null;

			KidsMessaging._containerEle.hide();

			if (KidsMessaging._backdrop != null) {
				KidsMessaging._backdrop.remove();
				KidsMessaging._backdrop = null;
			}

			KidsMessaging._isShowing = false;
			KidsMessaging._showingConfirm = false;
			$("#app-messaging").removeClass("overdriveBubble");
		}
	}
	static showDelayed(msg, delay, callback) {
		if (KidsMessaging._delayTimeout != null) {
			clearTimeout(KidsMessaging._delayTimeout);
		}

		KidsMessaging._delayTimeout = setTimeout(function () {
			KidsMessaging.show(msg);

			if (typeof callback === "function") {
				callback();
			}
		}, delay);
	}
	static showThenHide(msg, delay) {
		var success = KidsMessaging.show(msg);

		if (success) {
			if (KidsMessaging._hideTimeout != null) {
				clearTimeout(KidsMessaging._hideTimeout);
			}

			KidsMessaging._hideTimeout = setTimeout(function () {
				KidsMessaging.hide(true);
			}, delay);
		} else {
			KidsMessaging._hideMessageAferload = delay;
		}
	}
	static clearShowThenHideTimeout() {
		clearTimeout(KidsMessaging._hideTimeout);
	}
	static clearShowDelayedTimeout() {
		clearTimeout(KidsMessaging._delayTimeout);
	}
	static confirm(options) {
		var message = options.message;

		if (KidsMessaging._showingConfirm) {
			KidsMessaging.hide();
		}

		if (options.successButton || options.failButton || (options.buttons && options.buttons.length > 0)) {
			message += '<span class="buttons">';

			if (options.successButton) {
				let href = location.pathname + location.hash + '?__hold=' + options.successButton;
				let target = "";

				if (options.successButtonHref) {
					href = options.successButtonHref;
				}

				if (options.successButtonTarget) {
					target = options.successButtonTarget;
				}

				message += '<a class="exclude-timing-hack success" target="' + target + '" href="' + href + '">' + options.successButton + '</a> ';
			}

			if (options.buttons && options.buttons.length > 0) {
				var wrapperCustomClass = " ";

				if (options.wrapperCustomClass) {
					wrapperCustomClass += options.wrapperCustomClass;
				}

				message += '<span class="custom-buttons' + wrapperCustomClass + '">';

				for (var i = 0, len = options.buttons.length; i < len; i += 1) {
					let button = options.buttons[i];
					let href = location.pathname + location.hash + '?__' + options.buttons[i].id + '=' + options.buttons[i].label;
					message += '<a class="exclude-timing-hack custom-button" data-id="' +
						(button.id || "") + '" href="' + href + '">' + button.label + '</a>';
				}

				message += '</span>';
			}

			if (options.failButton) {
				message += '<a class="exclude-timing-hack fail" href="/kids#/?__' + options.failButton + '">' + options.failButton + '</a>';
			}


			message += '</span>';
		}

		KidsMessaging._backdrop = $('<div class="backdrop"></div>');
		$("#app-wrapper").append(KidsMessaging._backdrop);

		KidsMessaging.show(message);

		KidsMessaging._confirmOptions = options;

		KidsMessaging._showingConfirm = true;
	}
	static showOverdriveFulfillmentInterface(options) {
		if (KidsMessaging._showingConfirm) {
			KidsMessaging.hide();
		}

		var message = '<iframe id="kidsOverdriveIFrame" src="' + options.overDriveUrl + '"></iframe>';
		message += '<span class="buttons">';
		message += '<a class="exclude-timing-hack fail" href="/kids#/?__' + options.failButton + '">' + options.failButton + '</a>';
		message += '</span>';

		$("#app-messaging").addClass("overdriveBubble");

		KidsMessaging._backdrop = $('<div class="backdrop"></div>');
		$("#app-wrapper").append(KidsMessaging._backdrop);

		KidsMessaging.show(message);

		KidsMessaging._confirmOptions = options;

		KidsMessaging._showingConfirm = true;
	}
	static initEvents() {
		KidsMessaging._messageEle.on('click', 'a', function (e) {
			var options = KidsMessaging._confirmOptions;

			KidsMessaging.hide();

			var $linkEle = $(e.currentTarget);

			if ($linkEle.hasClass('success')) {
				if (!options.successButtonHref) {
					e.preventDefault();
					e.stopPropagation();
				}

				if (typeof options.successCallback === "function") {
					options.successCallback();
				}
			} else if ($linkEle.hasClass('fail')) {
				e.preventDefault();
				e.stopPropagation();

				if (typeof options.failCallback === "function") {
					options.failCallback();
				}
			} else if ($linkEle.hasClass('custom-button')) {
				e.preventDefault();
				e.stopPropagation();

				if (typeof options.successCallback === "function") {
					var id = $linkEle.data('id');
					if (id && id.length > 0) {
						options.successCallback(id);
					}
				}
			} else {
				window.location.href = $linkEle.attr('href');
			}
		});
	}
}
KidsMessaging._delayTimeout = null;
KidsMessaging._hideTimeout = null;

KidsMessaging._scout = null;

KidsMessaging._mainEle = null;
KidsMessaging._containerEle = null;
KidsMessaging._confirmOptions = null;
KidsMessaging._showMessageAferload = null;
KidsMessaging._hideMessageAferload = null;
KidsMessaging._initEvents = false;
KidsMessaging._isShowing = false;
KidsMessaging._backdrop = null;











